module.exports = __webpack_public_path__ + "static/media/file-medical.6eed2cee.svg";